export const PROVISION_STATUS_DEF_GET = "/ProvisionStatusDef/GetAllProvisionStatusDef"
